<div class="flex flex-center">
  <button type="button" matButton="outlined" (click)="input.click()" [disabled]="disabled() || loading()">
    @if (loading()) {
      <mat-icon class="spin">progress_activity</mat-icon>
    } @else {
      <mat-icon>{{ icon() }}</mat-icon>
    }
    {{ label() }}
  </button>
  <input type="file" [accept]="fileType()" hidden (change)="setFile(input.files?.item(0) ?? undefined)" #input />
  @if (showFileName()) {
    <p class="file-name">
      {{ value()?.name || 'Keine Datei ausgewählt' }}
    </p>
  }
</div>
